import { useRouter } from "next/router";
import { RefObject, useEffect, useRef } from "react";

interface Properties {
  scroll?: boolean;
  containerReference: RefObject<HTMLDivElement | null>;
  filterKeys: Array<string>;
}

export function useHandleScroll({
  scroll = true,
  containerReference,
  filterKeys
}: Properties) {
  const router = useRouter();
  const previousQuery = useRef(router.query);

  useEffect(() => {
    if (scroll && containerReference.current) {
      if (
        filterKeys.some(
          (key) => previousQuery.current[key] !== router.query[key]
        )
      ) {
        const top =
          window.scrollY +
          containerReference.current?.getBoundingClientRect().top -
          80;

        if (window.scrollY >= top) {
          window.scroll({
            top,
            behavior: "instant"
          });
        }
      }

      previousQuery.current = router.query;
    }
  }, [router.query]);
}
